/* Progressive enhancement: rates remain sourced from the Shopify page content. */
(() => {
  function enhance(root) {
    if (root.dataset.shippingReady) return;
    const source = root.querySelector('[data-shipping-source]');
    const tables = [...source.querySelectorAll('table')];
    const select = root.querySelector('#ob-shipping-country');
    const normalize = value => value.trim().toLowerCase().replace('czech republic', 'czechia');
    const available = new Map([...select.options].filter(o => o.value && o.value !== '---').map(o => [normalize(o.value), o.textContent.trim()]));
    if (tables.length !== 2 || !available.size) return;
    const groups = [];
    for (const [index, table] of tables.entries()) {
      const rows = [...table.querySelectorAll('tr')].map(row => [...row.children].map(cell => cell.textContent.trim()));
      const offset = index === 0 ? 3 : 2;
      const headers = rows[0].slice(offset);
      if (!headers.length || !headers.every(h => /\d+\s*kg/i.test(h))) return;
      for (const row of rows.slice(1)) {
        if (row.length !== headers.length + offset || !row.slice(offset).every(rate => /\d/.test(rate))) return;
        const rawCountries = row[index === 0 ? 1 : 0].split(',').map(normalize);
        const countries = rawCountries.filter(country => available.has(country));
        if (!countries.length) continue;
        const times = row[index === 0 ? 2 : 1];
        const rates = row.slice(offset);
        // Combine Baltic destinations only when their complete rates and times match.
        const same = index === 1 && groups.find(g => g.baltic && g.time === times && JSON.stringify(g.rates) === JSON.stringify(rates));
        if (same) same.countries.push(...countries);
        else groups.push({title:index === 0 ? row[0] : 'Baltic delivery', countries, time:times, headers, rates, baltic:index === 1});
      }
    }
    if (!groups.length) return;
    const el = (tag, cls, text) => {
      const node = document.createElement(tag);
      if (cls) node.className = cls;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    const container = root.querySelector('#ob-shipping-cards');
    const cards = groups.sort((a,b) => Number(b.baltic)-Number(a.baltic)).map(group => {
      const card = el('article', 'ob-shipping-card' + (group.baltic ? ' ob-shipping-card--baltic' : ''));
      const head = el('div', 'ob-shipping-card-head');
      head.append(el('h3', '', group.title),el('span','ob-shipping-time',group.time));
      card.append(head,el('p','ob-shipping-countries',group.countries.map(c => available.get(c)).join(' · ')));
      const rates = el('dl','ob-shipping-rates');
      group.headers.forEach((weight,i) => {
        const pair = el('div','ob-shipping-rate');
        pair.append(el('dt','',weight),el('dd','',group.rates[i]));
        rates.append(pair);
      });
      card.append(rates);
      container.append(card);
      return {card,group};
    });
    // Keep every non-table part of the authored content, including future notes.
    const copy = source.cloneNode(true);
    copy.querySelectorAll('table, style, script, br').forEach(node => node.remove());
    copy.querySelectorAll('.table-container, .tb-wrap').forEach(node => {if (!node.textContent.trim()) node.remove();});
    copy.querySelectorAll('h2,h3').forEach(heading => heading.remove());
    const paragraphs = [...copy.querySelectorAll('p')].filter(p => p.textContent.trim());
    const payment = root.querySelector('[data-shipping-payment-copy]');
    paragraphs.slice(0,2).forEach(p => payment.append(p));
    const extras = root.querySelector('[data-shipping-extras-copy]');
    extras.append(...copy.childNodes);
    function filter() {
      const country = normalize(select.value);
      let count = 0;
      cards.forEach(({card,group}) => {
        card.hidden = Boolean(country && !group.countries.includes(country));
        if (!card.hidden) count++;
      });
      container.classList.toggle('ob-shipping-cards--filtered', Boolean(country));
      const label = select.options[select.selectedIndex]?.textContent || '';
      root.querySelector('[data-shipping-status]').textContent = country ? (count ? 'Delivery rates for ' + label + '. Additional charges, where applicable, are listed below.' : 'Please contact us for delivery rates to ' + label + '.') : '';
    }
    select.addEventListener('change',filter);
    filter();
    source.querySelectorAll('style').forEach(node => node.remove());
    source.hidden = true;
    root.querySelectorAll('[data-shipping-enhanced]').forEach(node => {node.hidden=false;});
    root.dataset.shippingReady = 'true';
  }
  document.querySelectorAll('[data-ob-shipping]').forEach(enhance);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-ob-shipping]').forEach(enhance));
})();
